import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { SigninComponent } from './signin/signin.component';
import { SixDigitComponent } from './six-digit/six-digit.component';
import { HomeComponent } from './home/home.component';
import { GetLocationComponent } from './get-location/get-location.component';
import { WasteListComponent } from './waste-list/waste-list.component'
import { SelectedItemsComponent } from './selected-items/selected-items.component'
import { ProfileComponent } from './profile/profile.component'
import { MainPageComponent } from './main-page/main-page.component'
import { AboutUsComponent } from './about-us/about-us.component'
import { WalletComponent } from './wallet/wallet.component'
import { DoneComponent } from './done/done.component'
import { HistoryComponent } from './history/history.component'
import { ContactUsComponent } from './contact-us/contact-us.component'
import { TourComponent } from './tour/tour.component'
import { ServicesComponent } from './services/services.component'
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { from } from 'rxjs';
const routes: Routes = [
  { path: '', component: SplashScreenComponent },
  { path: 'login', component: LoginComponent },
  { path: 'signin', component: SigninComponent },
  { path: 'six-digit', component: SixDigitComponent },
  { path: 'home', component: HomeComponent },
  { path: 'get-location',  component: GetLocationComponent },
  { path: 'waste-list', component: WasteListComponent },
  { path: 'selected-items', component: SelectedItemsComponent },
  { path: 'profile', component: ProfileComponent },
  { path: 'main-page', component: MainPageComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'wallet', component: WalletComponent },
  { path: 'done', component: DoneComponent },
  { path: 'history', component: HistoryComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'tour', component: TourComponent },
  { path: 'services', component: ServicesComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  // providers: [{ provide: LoginGuard, useClass: LoginGuard }]
})
export class AppRoutingModule { }
